import { Checkbox } from '@mantine/core';
import { EnrollmentEffortTier } from '@zorro/clients';
import { Flex, Grid, Text } from '@zorro/web/design-system';

import { ENROLLMENT_EFFORT_TIER_LABELS } from '../../PlanBadge';
import classNames from './PlanFilter.module.scss';

export const ENROLLMENT_EFFORT_FILTER_VALUES = [
  EnrollmentEffortTier.EASY_ENROLL,
  EnrollmentEffortTier.EXTRA_STEPS,
  EnrollmentEffortTier.SELF_ENROLL,
] as const;

type Props = {
  filterOptions: Set<EnrollmentEffortTier> | undefined;
  selectedFilters: string[];
};

export const EnrollmentEffortFilters = ({
  filterOptions,
  selectedFilters,
}: Props) => {
  if (!filterOptions) {
    return null;
  }

  return (
    <Grid columns={2} gap="sm">
      {ENROLLMENT_EFFORT_FILTER_VALUES.filter((filter) =>
        filterOptions.has(filter)
      ).map((filter) => (
        <Grid.Col key={filter} span={1}>
          <Checkbox.Card
            checked={selectedFilters.includes(filter)}
            value={filter}
            className={classNames.checkboxCard}
          >
            <Flex p="md" align="center" gap="xs" h="3rem" justify="center">
              <Text>{ENROLLMENT_EFFORT_TIER_LABELS[filter]}</Text>
            </Flex>
          </Checkbox.Card>
        </Grid.Col>
      ))}
    </Grid>
  );
};
